/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('team')
}

const api = { getAll }


export default api;